module.exports = __webpack_public_path__ + "fonts/Open_Sans-700-latin-ext31.3e38266.woff2";